<template>
    <div>
        <div v-if="mcrHeader.type">
            <!-- <MassUpdateMrpForm v-if="(mcrHeader.type === 'MCR007' || mcrType === 'mass-update-mrp') && cataloguingFormConfig" ref="specialForm" :items="allMcrItem" :readonly="isFormReadonly" :form-config="cataloguingFormConfig" @open-attachment="openAttachment" /> -->

            <div class="card mt-2" style="box-shadow: none !important">
                <div
                    class="card-header px-1 pt-1 pb-2 d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <h6 class="mb-0 fw-semibold">MCR ITEM</h6>
                    <div class="d-flex flex-wrap align-items-center gap-2">
                        <button type="button" class="mb-0 btn btn-sm btn-primary text-white"
                            @click="openAttachment">Attachment</button>
                        <button v-if="mcrHeader?.status !== 'draft'" type="button" class="mb-0 btn btn-sm btn-primary"
                            @click="onTracking">Tracking</button>
                        <!-- Import & Add cuma di route pengisian MCR (showItemActions). -->
                        <button v-if="showImport" type="button" class="mb-0 btn btn-sm btn-primary"
                            @click="onImport">Import</button>
                        <!-- Add tidak ditampilkan untuk MASS UPDATE (MCR007): barisnya datang dari Import Excel, bukan input manual. -->
                        <button v-if="showItemActions && !isMassUpdateForm" type="button" class="mb-0 btn btn-sm btn-primary"
                            @click="onAdd">Add</button>
                        <!-- Referensi ConfigDataMapping yang mengisi otomatis field MRP / Profit Center (INALUM MCR001-MCR003). -->
                        <button v-if="showMappingReference" type="button" class="mb-0 btn btn-sm btn-primary text-white"
                            @click="mappingReference.visible = true"><i class="pi pi-sitemap me-1"></i>Mapping Reference</button>
                        <!-- Riwayat perubahan item (data log): semua mcr_type, butuh permission data-log-view (endpoint-nya dijaga permission itu). -->
                        <button v-if="showChangeLog" type="button" class="mb-0 btn btn-sm btn-primary text-white"
                            @click="changeLog.visible = true"><i class="pi pi-history me-1"></i>Change Log Item</button>
                    </div>
                </div>

                <UserForm v-if="getFormCode?.form_code === 'FORM01'" ref="userForm" :readonly="isFormReadonly" />
                <BlockUnblockForm v-else-if="getFormCode?.form_code === 'FORM03'" ref="blockUnblockForm" :readonly="isFormReadonly" />
                <FlagUnflagForm v-else-if="getFormCode?.form_code === 'FORM04'" ref="flagUnflagForm" :readonly="isFormReadonly" />
                <ChangeMasterDataForm v-else-if="getFormCode?.form_code === 'FORM07'" ref="changeMasterDataForm" :readonly="isFormReadonly" />
                <ConsolidationForm v-else-if="getFormCode?.form_code === 'FORM08'" ref="consolidationForm" :readonly="isFormReadonly" />
                <MassUpdateForm v-else-if="isMassUpdateForm" ref="massUpdateForm" :readonly="isFormReadonly" />
                <!-- item-deletable: tombol Delete item di tabel item = syarat tombol Add toolbar (showItemActions). -->
                <CataloguerForm v-else-if="getFormCode?.form_code === 'FORM02'" ref="cataloguerForm" :readonly="isFormReadonly"
                    :item-deletable="showItemActions && !isMassUpdateForm" />

                <template v-else>
                    <div class="card-body" style="text-align: center; padding: 40px 0;">
                        <img src="/no_data.png" alt="No Data"
                            style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
                        <div style="color: #888; font-size: 1.1em; font-weight: 500;">No Data</div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Attachment MCR (level header MCR): upload / preview / download / hapus -->
        <McrAttachmentDialog ref="attachmentDialog" />

        <!-- Dialog Tracking (digerakkan tombol Tracking di toolbar atas). Dialog-nya milik
             layout ini, sama seperti Attachment & Import — form yang dirender tidak perlu
             menyimpan state dialog sendiri. -->
        <DialogPrime v-model:visible="trackingModal.visible" modal :show-header="false"
            style="width: 50rem; margin: 10px;" @show="onTrackingShow">
            <Tracking ref="trackingRef" @close="trackingModal.visible = false" />
        </DialogPrime>

        <ItemChangeLogModal v-if="showChangeLog" v-model:visible="changeLog.visible" :items="allMcrItem"
            :selected-item-code="selectedMcrItem?.mcr_item_code || ''" />

        <MappingReferenceModal v-if="showMappingReference" v-model:visible="mappingReference.visible"
            :company="mcrCompany" :context-material-type="selectedItemMaterialType" />

        <!-- Dialog Import Excel (Reusable, digerakkan Vuex module importExcel) -->
        <ImportExcelModal module="importExcel" width="65rem" dialog-class="mcr-import-modal"
            :show-success-inline="false" @close="onImportClose" @success="onImportSuccess" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import UserForm from "./New_UserForm.vue";
import BlockUnblockForm from "./New_BlockUnblockForm.vue";
import FlagUnflagForm from "./New_FlagUnflagForm.vue";
import ChangeMasterDataForm from "./New_ChangeMasterDataForm.vue";
import ConsolidationForm from "./New_ConsolidationForm.vue";
import CataloguerForm from "./New_CataloguerForm.vue";
import ImportExcelModal from "@/components/ImportExcelModal.vue";
import MassUpdateForm from "./New_MassUpdateForm.vue";
import massUpdateMrpFormService from "@/services/materialCatalogingRequest/massUpdateMrpFormService";
import userFormService from "@/services/materialCatalogingRequest/userFormService";
import cataloguerFormService from "@/services/materialCatalogingRequest/cataloguerFormService";
import { findImportTemplate, downloadImportTemplate } from "@/helpers/importTemplate";
// import ExtendForm from "./ExtendForm.vue";
// import MassUpdateMrpForm from "./MassUpdateMrpForm.vue";
import McrAttachmentDialog from "./McrAttachmentDialog.vue";
import Tracking from "@/components/Tracking.vue";
import MappingReferenceModal from "./New_MappingReferenceModal.vue";
import ItemChangeLogModal from "./New_ItemChangeLogModal.vue";

// Route tempat tombol Import & Add MCR ITEM tampil (nama route di router/index.js).
const ITEM_ACTION_ROUTES = ["MCR Form for Draft", "MCR Form for My Task MCR"];

export default {
    name: "McrItem",
    components: {
        UserForm,
        BlockUnblockForm,
        FlagUnflagForm,
        ChangeMasterDataForm,
        ConsolidationForm,
        MassUpdateForm,
        CataloguerForm,
        // ExtendForm,
        // MassUpdateMrpForm,
        McrAttachmentDialog,
        ImportExcelModal,
        Tracking,
        MappingReferenceModal,
        ItemChangeLogModal
    },
    data() {
        return {
            importSuccessHandled: false,
            trackingModal: {
                visible: false,
                mcrCode: '',
            },
            mappingReference: {
                visible: false,
            },
            changeLog: {
                visible: false,
            },
        };
    },
    computed: {
        ...mapState({
            mcrHeader: (state) => state.mcr.mcrHeader,
            mcrDetail: (state) => state.mcr.mcrDetail,
            allMcrItem: (state) => state.mcr.allMcrItem || [],
            cataloguingFormConfig: (state) => state.mcr.cataloguingFormConfig,
            selectedMcrItem: (state) => state.mcr.selectedMcrItem,
        }),
        // Company MCR (header), fallback company user.
        mcrCompany() {
            return String(this.mcrHeader?.company || this.$store.state.auth?.user?.company_code || '').toUpperCase();
        },
        // Tombol Mapping Reference: cuma INALUM MCR001-MCR003 (mapping ConfigDataMapping yang dipakai form INALUM).
        showMappingReference() {
            return this.mcrCompany === 'INALUM' && ['MCR001', 'MCR002', 'MCR003'].includes(String(this.mcrHeader?.type || '').toUpperCase());
        },
        // Change Log Item: semua mcr_type (MCR001-MCR009, MCR010) yang punya item, cuma user dengan permission data-log-view.
        showChangeLog() {
            const type = String(this.mcrHeader?.type || '').toUpperCase();
            return /^MCR0(0[1-9]|10)$/.test(type);
        },
        // Material Type item terpilih (FORM02: cat_material_type, FORM01: material_type) -- filter awal modal.
        selectedItemMaterialType() {
            return this.selectedMcrItem?.cat_material_type || this.selectedMcrItem?.material_type || '';
        },
        isFromDraftAccess() {
            return this.$route.path.includes("draft");
        },
        isFromMaterialRequest() {
            return this.$route.path.includes("material-request");
        },
        // Type EMCR mentah (tanpa normalisasi) — jadi query param `type` di endpoint import.
        emcrType() {
            return this.mcrHeader?.type || "";
        },
        // MCR007 (MASS UPDATE) -- dipakai untuk memilih komponen form & service import. Dibaca dari type header MCR
        // (tidak bergantung form_code, jadi tetap benar walau baris mcr_form_type company/role-nya belum ada).
        isMassUpdateForm() {
            const type = (this.mcrHeader?.type || '').toLowerCase().replace(/\s+/g, '-');
            return type === 'mcr007' || type === 'mass-update-mrp';
        },
        // Form read-only kalau diakses dari draft yang sudah tidak berstatus draft,
        // atau dari Material/Service Request (bukan draft).
        isFormReadonly() {
            // Satu sumber dengan tombol Save footer: getter mcr/isFormEditable (meta.formMode route + mcr_form_access).
            return !this.$store.getters['mcr/isFormEditable'];
        },
        getFormCode() {
            return this.$store.getters['mcr/getFormCode']
        },
        // Tombol Import & Add: cuma di route pengisian MCR (draft & my-task). Form Cataloguer (FORM02) dipakai banyak
        // company/role, jadi di sana cuma ANTAM MCR001-MCR002 untuk role User / Inventory Control, dan cuma saat MCR draft /
        // send_back (dikembalikan ke User, boleh menambah item baru; BE Import & Add menerima kedua status itu).
        showItemActions() {
            if (!ITEM_ACTION_ROUTES.includes(this.$route.name)) return false;
            if (this.getFormCode?.form_code === 'FORM02') {
                return this.canAccessItemActions && ['draft', 'send_back'].includes(String(this.mcrHeader?.status || '').toLowerCase());
            }
            return true;
        },
        // Import item tidak dipakai MCR010 (change master data) & MCR006 (consolidation): datanya
        // tidak dimaintain lewat file, cukup tambah baris manual dari grid FORM07/FORM08.
        showImport() {
            const type = String(this.mcrHeader?.type || '').toUpperCase();
            return this.showItemActions && !['MCR006', 'MCR010'].includes(type);
        },
        canAccessItemActions() {
            const auth = this.$store.state.auth || {};
            const type = (this.mcrHeader?.type || '').toUpperCase();
            const roles = (auth.userHasRoles || []).map((role) => (typeof role === 'string' ? role : role?.name));
            return auth.user?.company_code === 'ANTAM'
                && ['MCR001', 'MCR002'].includes(type)
                && roles.some((role) => ['User', 'Inventory Control'].includes(role));
        }
    },
    methods: {
        openAttachment() {
            this.$refs.attachmentDialog?.open();
        },
        // Toolbar MCR ITEM dipasang sekali di sini supaya markup tombol tidak
        // diulang di tiap komponen form (termasuk dialog Tracking/Attachment/Import).
        // Owner toolbar ini masih perlu ref form yang sedang dirender untuk refresh
        // data (setelah import / tambah baris) — tiap form punya ref sendiri.
        activeForm() {
            return this.$refs.userForm || this.$refs.blockUnblockForm || this.$refs.flagUnflagForm || this.$refs.changeMasterDataForm || this.$refs.consolidationForm || this.$refs.massUpdateForm || this.$refs.cataloguerForm || null;
        },
        // Form yang dirender tidak lagi punya dialog tracking sendiri — state-nya di sini.
        onTracking() {
            this.trackingModal.mcrCode = this.mcrHeader?.mcr_code || this.$route.params.mcrCode || this.$route.params.id || '';
            this.trackingModal.visible = true;
        },
        // Dipanggil setelah DialogPrime selesai mount kontennya (ref sudah siap)
        onTrackingShow() {
            this.$refs.trackingRef?.getTracking({
                type: ['start', 'approval'],
                code: 'MCR',
                key: this.trackingModal.mcrCode,
                result: ['success', 'approve', 'send_back', 'reject'],
            });
        },
        onImport() {
            const idEmcr = this.mcrHeader?.id;
            if (!idEmcr) {
                this.$toastNotifPrime('error', 'Error', 'MCR data is not loaded yet');
                return;
            }
            // Dialog import digerakkan state Vuex module importExcel, jadi parent
            // cukup dispatch — tidak perlu memanggil method UserForm lewat ref.
            this.importSuccessHandled = false;
            // Template: MCR007 (FORM06) dari BE mass-update; selain itu file di src/assets/template_import_excel sesuai
            // company user + mcr_type header (tombol tampil kalau filenya ada).
            const company = this.$store.state.auth?.user?.company_code;
            const assetTemplate = !this.isMassUpdateForm && findImportTemplate(company, this.emcrType);
            this.$store.dispatch('importExcel/openDialog', {
                config: {
                    title: 'Import Items',
                    acceptTypes: '.xls,.xlsx',
                    templateLabel: 'Download Template',
                    importLabel: 'Import Items',
                    cancelLabel: 'Cancel',
                    showTemplateButton: this.isMassUpdateForm || !!assetTemplate,
                },
                id: idEmcr,
                service: this.importService(),
                templateService: this.isMassUpdateForm
                    ? massUpdateMrpFormService.downloadTemplate
                    : (assetTemplate ? () => downloadImportTemplate(company, this.emcrType) : null),
            });
        },
        // Endpoint import per form: MCR007 (FORM06) mass-update, Cataloguer (FORM02) catalouging-form/import (payload Save Draft
        // ANTAM), selain itu user-form/import.
        importService() {
            if (this.isMassUpdateForm) return (emcrId, file) => massUpdateMrpFormService.importItems(emcrId, file);
            if (this.getFormCode?.form_code === 'FORM02') return (emcrId, file) => cataloguerFormService.importItems(emcrId, file);
            return (emcrId, file) => userFormService.importEmcr(emcrId, file, this.emcrType);
        },
        async onImportSuccess() {
            if (this.importSuccessHandled) return;
            this.importSuccessHandled = true;
            const successMsg = this.$store.state.importExcel?.successMessage || 'Import completed successfully';
            this.$store.dispatch('importExcel/closeDialog');
            this.$toastNotifPrime('success', 'Success', successMsg);
            if (this.$refs.userForm) {
                // Tabel item dimiliki UserForm, jadi refresh datanya lewat method di sana.
                this.$refs.userForm.onItemDialogSaved();
            } else if (this.$refs.cataloguerForm) {
                // Daftar item Cataloguer dimuat New_CataloguerForm sendiri -> muat ulang di sana.
                this.$refs.cataloguerForm.fetchViewData();
            } else if (this.$refs.blockUnblockForm || this.$refs.flagUnflagForm || this.$refs.changeMasterDataForm || this.$refs.consolidationForm || this.$refs.massUpdateForm) {
                // BlockUnblockForm/FlagUnflagForm/ChangeMasterDataForm/ConsolidationForm baca items dari store, jadi cukup trigger refresh —
                // McrForm yang fetch ulang header + allMcrItem.
                this.$store.dispatch('mcr/triggerRefresh');
            }
            this.importSuccessHandled = false;
        },
        onImportClose() {
            this.importSuccessHandled = false;
        },
        // Semua form yang bisa dirender (UserForm / BlockUnblockForm / FlagUnflagForm / CataloguerForm) punya
        // addNewItem(), jadi cukup lewat activeForm() — tidak perlu nambah cabang tiap ada form baru.
        // CataloguerForm: addNewItem() membuka AddItemModal miliknya.
        onAdd() {
            this.activeForm()?.addNewItem?.();
        },
    }
}
</script>